export const LINK_LIST = 'LINK_LIST';

export default {
  LINK_LIST,
};
